import { PropsWithChildren } from 'react';

import { FormSubmit } from 'libs/form';

import {
  OnboardingSettingsFormType,
  Form,
  getSchema,
} from '../../forms/onboardingSettingsForm';

export interface OnboardingSettingsFormProps {
  initialValues?: Partial<OnboardingSettingsFormType>;
  onSubmit: FormSubmit<OnboardingSettingsFormType>;
}

export const OnboardingSettingsForm = ({
  initialValues,
  children,
  onSubmit,
}: OnboardingSettingsFormProps & PropsWithChildren) => {
  const schema = getSchema();

  return (
    <Form
      initialReadOnly
      initialValues={initialValues}
      validationSchema={schema}
      onSubmit={onSubmit}
    >
      {children}
    </Form>
  );
};
